import { Component, OnInit, OnDestroy, ViewContainerRef, Input, SimpleChanges, OnChanges, TemplateRef } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Globals } from '../../globals';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'app-inforuser',
    templateUrl: './inforuser.component.html',
    styleUrls: ['./inforuser.component.css']
})
export class InforuserComponent implements OnInit, OnChanges, OnDestroy {

    fm: FormGroup;
    fmchangePassword: FormGroup
    @Input('id') id: number;
    public connect: any;
    public token: any = {
        updateCustommer: "api/updateuser",
        getrowcustomer: "api/getuserId",
        changePassword: "api/changePasswordcustomer"
    }
    public listgroup: any;
    public maxDate = new Date();
    modalRef: BsModalRef;
    constructor(
        public fb: FormBuilder,
        public router: Router,
        public toastr: ToastsManager,
        vcr: ViewContainerRef,
        public globals: Globals,
        private modalService: BsModalService,
        private routerAct: ActivatedRoute,
        public translate: TranslateService,
    ) {
        this.toastr.setRootViewContainerRef(vcr);
        this.connect = this.globals.result.subscribe((response: any) => {
            switch (response['token']) {
                case 'getrowcustomer':
                    let data = response['data'];
                    data.id = this.id;
                    data.birth_date = new Date(data.birth_date)
                    this.fmConfigs(data);
                    break;
                case 'changePassword':
                    let type = (response['status'] == 1) ? "success" : (response['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](response['message'], type);
                    break;
                case 'updateCustommer':
                    type = (response['status'] == 1) ? "success" : (response['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](response['message'], type);
                    if (response['status'] == 1) {
                        setTimeout(() => {
                            this.router.navigate(['/thong-tin-cua-toi/', this.id]);
                        }, 2000);
                    }
                    break
                default:
                    break;
            }
        });
    }

    ngOnInit() {
        this.fmConfigs()
    }
    ngOnChanges(changes: SimpleChanges): void {
        if (this.id && this.id != 0) {
            this.globals.send({ path: this.token.getrowcustomer, token: 'getrowcustomer', params: { id: this.id } });
        }
    }
    ngOnDestroy() {
        this.connect.unsubscribe();
    }

    onSubmit() {
        let data = this.fm.value;
        data.status = (data.status == true) ? 1 : 0;
        this.globals.send({ path: this.token.updateCustommer, token: 'updateCustommer', data: data });
    }
    fmConfigs(item: any = "") {
        item = typeof item === 'object' ? item : { status: 1, type: 1, birth_date: this.maxDate };
        this.fm = this.fb.group({
            birth_date: item.birth_date ? item.birth_date : '',
            sex: +item.sex ? + item.sex : '',
            email: [item.email ? item.email : '', [Validators.required, Validators.pattern(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i)]],
            phone: [item.phone ? item.phone : '', [Validators.pattern(/[0-9\+\-\ ]/)]],
            address: item.address ? item.address : '',
            name: [item.name ? item.name : '', [Validators.required]],
            id: +item.id ? +item.id : 0,
        })
    }
    
}



// WEBPACK FOOTER //
// ./src/app/frontend/inforuser/inforuser.component.ts